import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Palette,
  Monitor,
  Clock,
  Settings as SettingsIcon,
  ChevronLeft,
  ChevronRight,
  Menu
} from 'lucide-react';

const SettingSideBar = () => {
  const tenantName = localStorage.getItem('tenantName');
  const location = useLocation();
  const currentPath = location.pathname;
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      // Auto-collapse on mobile by default
      if (window.innerWidth <= 768) {
        setIsCollapsed(true);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const settingItems = [
    {
      path: `/Setting/Appearance`,
      name: "Appearance",
      icon: <Palette size={18} />
    },
    {
      path: `/Setting/displayrules`,
      name: "Display Rules",
      icon: <Monitor size={18} />
    },
    {
      path: `/Setting/operating-hour`,
      name: "Operating Hours",
      icon: <Clock size={18} />
    }
  ];

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>
      {/* Mobile Toggle Button (always visible on mobile) */}
      {isMobile && (
        <button 
          onClick={toggleSidebar}
          className="mobile-sidebar-toggle"
          aria-label="Toggle settings menu"
        >
          <Menu size={20} />
        </button>
      )}

      {/* Sidebar */}
      <div className={`settings-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="settings-header">
          {!isCollapsed && (
            <>
              <SettingsIcon size={20} />
              <h3 className="settings-title">Settings</h3>
            </>
          )}
          <button 
            onClick={toggleSidebar}
            className="sidebar-toggle-btn"
            aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
          </button>
        </div>
        
        <nav className="settings-nav">
          {settingItems.map((item) => (
            <Link
              key={item.path}
              to={`/${tenantName}/chat${item.path}`}
              className={`settings-link ${currentPath.includes(item.path) ? 'active' : ''}`}
              title={isCollapsed ? item.name : ''}
            >
              <span className="settings-icon">{item.icon}</span>
              {!isCollapsed && <span className="settings-name">{item.name}</span>}
            </Link>
          ))}
        </nav>
      </div>
    </>
  );
};

export default SettingSideBar;